// Geld lebt als ganze Cent (Kern-Typ `Cent`) und wird erst zur Anzeige zu Euro. Keine
// Fließkomma-Rechnung: wir teilen nur beim Formatieren durch 100.
const euroFormat = new Intl.NumberFormat("de-DE", {
  style: "currency",
  currency: "EUR",
});

/** Formatiert einen ganzzahligen Cent-Betrag als Euro-Zeichenkette (z. B. 1290 → „12,90 €"). */
export function euro(cent: number): string {
  return euroFormat.format(cent / 100);
}
